<template>
    <transition name="fade-in-top-btn" mode="out-in">
        <Button class="back-to-top" display="icon" @click="toTop" v-if="isVisible">
            <SVGicon-up-arrow />
            <span>Top</span>
        </Button>
    </transition>
</template>

<script>
import gsap from 'gsap'

export default {
    data() {
        return {
            isVisible: true,
            lastPos: 0,
            windowHeight: 0
        }
    },

    created () {
        window.addEventListener('scroll', this.toggleVisibility)
        window.addEventListener('resize', this.setWindowHeight)

        this.setWindowHeight()
        this.toggleVisibility()
    },

    mounted () {
        this.lastPos = window.pageYOffset || document.documentElement.scrollTop
    },

    methods: {
        setWindowHeight () {
            this.windowHeight = window.innerHeight || document.documentElement.scrollTop
        },

        toggleVisibility () {
            const currScroll = window.pageYOffset || document.documentElement.scrollTop

            if (currScroll > this.lastPos) this.isVisible = false
            else {
                this.isVisible = true
                 if(currScroll < this.windowHeight / 2) this.isVisible = false
            }

            this.lastPos = currScroll <= 0 ? 0 : currScroll
        },

        toTop () {
            gsap.to(window, {
                scrollTo: 0,
                duration: .25,
                ease: 'power4.easeOut'
            })
        }
    },

    beforeDestroy() {
        window.addEventListener('resize', this.setWindowHeight)
        window.removeEventListener('scroll', this.toggleVisibility)
    },
}
</script>

